const GUIDE_PATH =
  /^\/guides\/(?:[A-Za-z0-9._~-]+\/)*[A-Za-z0-9._~-]+(?:\?[A-Za-z0-9._~!$&'()*+,;=:@%/?-]*)?(?:#[A-Za-z0-9._~-]*)?$/;

export function safeGuideReturnTo(value) {
  const candidate = String(value || '').trim();
  if (!candidate || candidate.startsWith('//') || !GUIDE_PATH.test(candidate)) return null;
  try {
    const decodedPath = decodeURIComponent(candidate.split(/[?#]/)[0]);
    if (decodedPath.split('/').some((segment) => segment === '.' || segment === '..')) return null;
  } catch {
    return null;
  }
  return candidate;
}

export function guideReturnToFromSearch(search) {
  return safeGuideReturnTo(new URLSearchParams(search || '').get('returnTo'));
}
